@if (assets()) {
  <div class="row title-row mt-4 grid grid-cols-2">
    <div class="col-6">
      <div class="table-title flex text-md lg:text-2xl">Assets
        <app-info-icon tooltipClass="info-icon-top-0" tooltipPosition="right"
          tooltipInfo="Underlying Portfolio Company, Real Estate, and Infrastructure assets for the Deal"
          data-cy="assetTableTooltip">
        </app-info-icon>
      </div>
      <div class="since-inception-text mb-3 text-sm lg:text-md" data-cy="assetTableSubHeaderText">Since Inception
      | Expressed in millions</div>
    </div>
    <div class="col-6 flex flex-row flex-wrap pl-0 expanded-export">
      <app-expanded-view-slider (updateTableColumns)="updateColumns($event)"
      [expandView]="expandView"></app-expanded-view-slider>
      <div class="text-right">
        @if (assets() && assets()?.length > 0 && asOfDate();) {
          <button (click)="exportAssetsDataToCsv($event)"
            class="export-csv-btn text-xs lg:text-md" data-cy="exportCsvButton"><mat-icon
          fontSet="material-icons-outlined" class="export-icon">content_paste_go</mat-icon> Export to
        Excel</button>
      }
    </div>
  </div>
</div>
@if (assets() && assets()?.length > 0) {
  <div class="card deals-assets-card m-0 w-full" data-cy="dealsAssetCard"
    >
    <div class="overflow-x-auto" data-cy="scrollAssetsTable" (scroll)="scrollAssetsTableHandler($event)">
      <table mat-table matSort [dataSource]="dataSource" class="lg:w-full"
        [ngClass]="expandView ? 'w-[1400px]' : 'w-[1100px]'">
        <!-- Asset Name Column -->
        <ng-container matColumnDef="name" sticky>
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-14' : 'width-20'"
            [ngClass]="displayShadowOnAssetsTable ? 'shadow-background' : 'normal-background'"> Asset Name
          </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md font-bold"
                        [ngClass]="{'width-14' : expandView, 'width-20' : !expandView, 'asset-name' : asset.isLinkable && !asset.isSubRow, 'asset-name-disabled' : !asset.isLinkable || asset.isSubRow,
                        'shadow-background' : displayShadowOnAssetsTable, 'normal-background' : !displayShadowOnAssetsTable}" attr.data-cy="asset{{asset.masterId}}">
            @if (!asset.isSubRow) {
              @if (asset.isLinkable) {
                <a routerLinkActive="active"
                  [routerLink]="['/investor', investorId(), 'series',seriesId(), 'deal', dealId(), 'asset', asset.masterId]"
                  [queryParams]="{'reportingdate':reportingPeriod()}"
                  (click)="activityTracking.navigateToDashboard('Asset', asset, 'assets detail table')"
                  data-cy="assetName">
                  {{asset.name}}
                </a>
              } @else {
                <span data-cy="assetName">{{asset.name}}</span>
              }
            }
          </td>
        </ng-container>
        <!-- Currency Column -->
        <ng-container matColumnDef="assetCurrency">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-6' : 'width-8'"> Currency </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-6' : 'width-8'" data-cy="assetCurrency">
            {{asset.currency}}
          </td>
        </ng-container>
        <!-- Acquisition Date Column -->
        <ng-container matColumnDef="acquisitionDate">
          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
            class="text-left text-sm lg:text-md" [ngClass]="expandView ? 'width-7' : 'width-10'">
          Acquisition Date </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-7' : 'width-10'" [attr.data-cy]="asset.isParentRow ? null : 'assetDate'">
            {{asset.acquisitionDate | dateFormat: 'M/d/yy'}}
          </td>
        </ng-container>
        <!-- Remaining Cost Basis Column -->
        <ng-container matColumnDef="remainingCostBasis">
          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef class="text-right pr-5"
          [ngClass]="expandView ? 'width-7' : 'width-10'"> Remaining Cost Basis </th>
          <td mat-cell *matCellDef="let asset" class="text-right pr-10"
            [ngClass]="expandView ? 'width-7' : 'width-10'" [attr.data-cy]="asset.isParentRow ? null : 'assetBalanceValue'">
            @if (!asset.isParentRow) {
              {{asset.remainingCostBasis | currencyFormat:asset.currency:'Millions':true:true}}
            }
          </td>
        </ng-container>
        <!-- Remaining Market Value Column -->
        <ng-container matColumnDef="remainingMarketValue">
          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef class="text-right pr-5"
          [ngClass]="expandView ? 'width-10' : 'width-13'"> Remaining Market Value </th>
          <td mat-cell *matCellDef="let asset" class="text-right pr-10"
            [ngClass]="expandView ? 'width-10' : 'width-13'" [attr.data-cy]="asset.isParentRow ? null : 'assetBalanceValue'">
            @if (!asset.isParentRow) {
              {{asset.remainingMarketValue | currencyFormat:asset.currency:'Millions':true:true}}
            }
          </td>
        </ng-container>
        <!-- Statement Date Column -->
        <ng-container matColumnDef="statementDate">
          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
            class="text-left text-sm lg:text-md" [ngClass]="expandView ? 'width-8' : 'width-10'">
          Statement Date </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-8' : 'width-10'" [attr.data-cy]="asset.isParentRow ? null : 'assetDate'">
            {{asset.mostRecentSoiDate | dateFormat: 'M/d/yy'}}
          </td>
        </ng-container>
        <!-- Sector Column -->
        <ng-container matColumnDef="sector">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md"
          [ngClass]="expandView ? 'width-8' : 'width-14'"> Sector </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-8' : 'width-14'" data-cy="assetSector">
            {{asset.sector}}
          </td>
        </ng-container>
        <!-- Sub-Sector Column -->
        <ng-container matColumnDef="subSector">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md"
          [ngClass]="expandView ? 'width-10' : 'width-16'"> Sub-Sector </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-10' : 'width-16'" data-cy="assetSubSector">
            {{asset.subSector}}
          </td>
        </ng-container>
        <!-- Exit Date Column -->
        <ng-container matColumnDef="exitDate">
          <th mat-header-cell mat-sort-header start="desc" *matHeaderCellDef
            class="text-left text-sm lg:text-md" [ngClass]="expandView ? 'width-8' : 'width-10'"> Exit
          Date </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md"
            [ngClass]="expandView ? 'width-8' : 'width-10'" [attr.data-cy]="asset.isParentRow ? null : 'assetDate'">
            {{asset.exitDate | dateFormat: 'M/d/yy'}}
          </td>
        </ng-container>
        <!-- Expanded View Columns -->
        <!-- Geography Column -->
        <ng-container matColumnDef="geography">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md width-8"
          data-cy="expandedOnlyLabel"> Geography </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md width-6"
            data-cy="assetRegion">
            {{asset.mapRegion}}
          </td>
        </ng-container>
        <!-- Country Column -->
        <ng-container matColumnDef="country">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md width-8"
          data-cy="expandedOnlyLabel"> Country </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md width-6"
            data-cy="assetCountry">
            {{asset.country}}
          </td>
        </ng-container>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell mat-sort-header *matHeaderCellDef class="text-left text-sm lg:text-md width-6"
          data-cy="expandedOnlyLabel"> Status </th>
          <td mat-cell *matCellDef="let asset" class="text-left text-sm lg:text-md width-8"
            data-cy="assetStatus">
            {{asset.status}}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
        <tr mat-row *matRowDef="let asset; columns: columnsToDisplay;"
          [ngClass]="{'parent-row': asset.isParentRow, 'sub-row': asset.isSubRow}"
        tourAnchor="deal.dashboard.assetTable"></tr>
      </table>
    </div>
  </div>
} @else {
  <div class="w-full series-table-error" data-cy="noResults">
    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div>
            <p class="text-center error-message">No Results</p>
          </div>
        </div>
      </div>
    </div>
  </div>
}
}
